<template>
  <div class="activityDetailsDoubleTwelvePage">
    <van-loading v-if="loading"
                 type="spinner"
                 color="#F0D19E"
                 vertical>加载中...</van-loading>
    <div v-if="!loading"
         class="content">
      <div class="img_bg">
        <img src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/30a52d45541c415690d45c31dddeb5b1.png"
             alt="">
      </div>
      <img class="activity_rule"
           src="../../sprite/activity_rule.png"
           alt=""
           @click="handleViewRule">
      <div class="tabBox">
        <div @click="handleCheckTab(101)"
             class="tabItem"
             :class="{'currentClass': current == 1}">佣金加码</div>
        <div @click="handleCheckTab(2)"
             class="tabItem"
             :class="{'currentClass': current == 2}">月度榜单</div>
      </div>
      <div class="activity1"
           v-if="current == 1"
           :style="{'padding-bottom': isShowFixedBtn ? '2.27rem' : '0.4rem'}">
        <div class="subsidy_user">
          <img class="subsidy_title"
               src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/e534d8438bfa4d828827a873144c258a.png"
               alt="">
          <div class="subsidy_box">
            <img v-if="!isBegin"
                 class="no_begin"
                 src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/36ac3e032e0344b5bec932d35e37bdb8.png"
                 alt="">
            <div class="act_date">
              <div :class="['item_date',{'currentDateClass': currentId == item.id}]"
                   :style="{'width': 100/dateArr.length+'%'}"
                   v-for="(item, index) in dateArr"
                   :key="index"
                   @click="handleCheckDate(item)">{{item.actDate}}</div>
            </div>
            <div class="all_activity"
                 v-for="(item, index) in activityArr"
                 :key="index">
              <div class="order_standard_box"
                   v-if="currentId == item.id">
                <div class="title_box">
                  <div>本阶段推广<br />订单量达</div>
                  <span v-for="(item2, index2) in item.bonusCfg"
                        :key="index2">
                    (日均<span>{{item2.bonusLevelName || 0}}</span>单)<br />
                    达成<span>{{item2.orderCountMinRequired || 0}}</span>单
                  </span>
                </div>
                <div class="progress_box">
                  <div class="progress_all"></div>
                  <div class="progress_in"
                       :style="{width: progressIn + '%'}"></div>
                  <div class="stage_box">
                    <div :class="['stage','stageall',{'curStage': commissionOrderCount>=item.bonusCfg[0].orderCountMinRequired}]"></div>
                    <div :class="['stage',{'curStage': commissionOrderCount>=item.bonusCfg[1].orderCountMinRequired}]"></div>
                    <div :class="['stage',{'curStage': commissionOrderCount>=item.bonusCfg[2].orderCountMinRequired}]"></div>
                  </div>
                </div>
                <div class="standard_box">
                  <span class="tip_box">
                    <div class="station_tip"><span>用来占位</span></div>
                    <span>每单补贴</span>
                  </span>
                  <div v-for="(item2, index2) in item.bonusCfg"
                       :key="index2">
                    <div class="subsidy_tip"
                         v-if="item2.prizeCard"><span>{{item2.prizeCard}}</span></div>
                    <img src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/71d80e45e053421188a990efeb76ff58.png"
                         alt="">
                    <p class="p1"><span>{{item2.bonusAmount || 0}}</span>元</p>
                    <p class="p2">1单补贴</p>
                    <p class="p3">达成{{item2.orderCountMinRequired}}单</p>
                  </div>
                </div>
                <div class="tip">*仅报名大使可获得补贴</div>
              </div>
            </div>
          </div>
          <div class="user_login_box">
            <div class="user_con">
              <div class="user_box">
                <img :src="token ? userInfo.avatarUrl : require('../../sprite/no_login.png')"
                     alt="">
                <div class="my_order_info"
                     v-if="!token">
                  <div class="no_login_tip">未登录</div>
                  <div class="my_order">我的订单量：登录后可查看</div>
                </div>
                <div class="my_order_info"
                     v-if="token">
                  <div class="no_join"
                       v-if="!isJoinActivity1">您还未报名该活动</div>
                  <div :class="['my_order',{'weightColor': isJoinActivity1}]"
                       v-if="isJoinActivity1">我的订单量：{{commissionOrderCount}}</div>
                  <div class="order_tip"
                       v-if="isJoinActivity1">
                    <span v-if="commissionOrderCount < bonusCfg[0].orderCountMinRequired">暂未达到补贴门槛</span>
                    <span v-if="commissionOrderCount >= bonusCfg[0].orderCountMinRequired && commissionOrderCount < bonusCfg[1].orderCountMinRequired">预计单笔订单补贴¥{{bonusCfg[0].bonusAmount || 0}}</span>
                    <span v-if="commissionOrderCount >= bonusCfg[1].orderCountMinRequired && commissionOrderCount < bonusCfg[2].orderCountMinRequired">预计单笔订单补贴¥{{bonusCfg[1].bonusAmount || 0}}</span>
                    <span v-if="commissionOrderCount >= bonusCfg[2].orderCountMinRequired">预计单笔订单补贴¥{{bonusCfg[2].bonusAmount || 0}}</span>
                  </div>
                </div>
              </div>
              <div class="login_btn"
                   v-if="!token"
                   @click="goLogin">立即登录</div>
              <div class="join_btn"
                   v-if="token && !isJoinActivity1"
                   @click="goJoin1">立即报名</div>
            </div>
            <div class="login_tip"
                 v-if="isJoinActivity1 && commissionOrderCount >= bonusCfg[0].orderCountMinRequired && isActivityEnd1 && !activityInfo1.isSendPrize">补贴金¥{{ subsidyMoney }}，预计发放时间2023年1月10日23:59前
            </div>
            <div class="login_tip"
                 v-if="isJoinActivity1 && commissionOrderCount >= bonusCfg[0].orderCountMinRequired && isActivityEnd1 && activityInfo1.isSendPrize">¥{{ subsidyMoney }}补贴已发放<span
                    @click="goEventRewards">&nbsp;&nbsp;&nbsp;&nbsp;查看详情></span></div>
          </div>
          <div class="product_box1"
               v-if="productList1.length > 0">
            <img class="title_icon"
                 src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/6781a05f88d4420f8046cafa17991216.png"
                 alt="">
            <ul>
              <li v-for="(item, index) in productList1"
                  :key="index"
                  @click="shareHandle(item)">
                <img class="item_img"
                     :src="item.productImage"
                     alt="">
                <div class="right_des">
                  <div class="title">{{item.productName}}</div>
                  <div class="des_bottom_box">
                    <div class="money">
                      <div class="price">￥<span>{{item.salePrice || 0}}</span></div>
                      <div class="commision">佣金¥{{item.oneCommission || 0}}</div>
                    </div>
                    <div class="promote_now_btn">立即推广</div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="activity_explain">
            <img class="title_icon"
                 src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/0b80deb844484a4986d099b585742d08.png"
                 alt="">
            <div class="explain">
              <p>1、参与方式：本活动只对报名大使进行结算，请先点击报名</p>
              <p>2、统计范围：指定补贴品为芒果TV会员年卡，仅计算一级订单（退单/无效订单不计入）</p>
              <p>3、大使获得的现金补贴＝个人订单量*补贴金，按结束时单量所在档位补贴，每阶段仅可以领取一次，不叠加领取（详见规则）</p>
            </div>
          </div>
          <div class="community_box">
            <img class="bg"
                 src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/b4dd94e849f1441ab3b1221f7e8b4f38.png"
                 alt="">
            <img class="qdcode"
                 src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/40d9f55864bf42edaab5876745036aae.jpg"
                 alt="">
          </div>
        </div>
        <!-- 已报名，活动未开始 -->
        <div class="fixed_bottom_btn"
             v-if="isJoinActivity1 && !isActivityStart1">
          <img src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/2b7f16f7cbc14c7997e395c4109f0d5a.png"
               alt="">
          <div>活动开始时间：{{activityInfo1.startTime && activityInfo1.startTime.slice(0,10)}}</div>
        </div>
        <!-- 已报名，活动已结束 -->
        <div class="fixed_bottom_btn"
             v-if="isJoinActivity1 && isActivityEnd1">
          <img src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/a991cb37c33643b18ea570febcee9a2c.png"
               alt="">
        </div>
        <!-- 未报名，活动未开始-->
        <div class="fixed_bottom_btn"
             v-if="!isJoinActivity1 && !isActivityStart1">
          <img src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/2b7f16f7cbc14c7997e395c4109f0d5a.png"
               alt="">
          <div>活动开始时间：{{activityInfo1.startTime && activityInfo1.startTime.slice(0,10)}}</div>
        </div>
        <!-- 未报名，活动已开始，未结束-->
        <div class="fixed_bottom_btn"
             v-if="!isJoinActivity1 && isActivityStart1 && !isActivityEnd1">
          <img src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/73b83e88754046cab4550d64f6df33b9.png"
               alt=""
               @click="goJoin1">
        </div>
        <!-- 未报名，活动已结束-->
        <div class="fixed_bottom_btn"
             v-if="!isJoinActivity1 && isActivityEnd1">
          <img src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/a991cb37c33643b18ea570febcee9a2c.png"
               alt="">
        </div>
      </div>
      <div class="activity2"
           v-if="current == 2">
        <div class="main_body_box">
          <div class="desc_box">
            <img class="title_img"
                 src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/d6a89251a31b4cdfb6283396e4df4a1f.png"
                 alt="">
            <img class="desc_rule_img"
                 src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/690775c0751d4a9e89314b3566df67e2.png"
                 alt="">
          </div>
          <div class="product_box2"
               v-if="productList23.length > 0">
            <img class="title_icon"
                 src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/ef4ffc67b50c435dacdcb2934582358d.png"
                 alt="">
            <ul>
              <li v-for="(item, index) in productList23"
                  :key="index"
                  @click="shareHandle(item)">
                <img class="item_img"
                     :src="item.productImage"
                     alt="">
                <div class="right_des">
                  <div class="title">{{item.productName}}</div>
                  <div class="des_bottom_box">
                    <div class="money">
                      <div class="price">￥<span>{{item.salePrice || 0}}</span></div>
                      <div class="commision">佣金¥{{item.oneCommission || 0}}</div>
                    </div>
                    <div class="promote_now_btn">立即推广</div>
                  </div>
                </div>
              </li>
            </ul>
            <div class="more_btn"
                 @click="$router.push('/')">查看更多></div>
          </div>
          <div class="rank_box">
            <img class="rank_grad_bg"
                 src="../../sprite/rank_grad_bg.png"
                 alt="">
            <img class="title_icon"
                 src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/9057f6bf53954dfb812fde38b88dba6b.png"
                 alt="">
            <div class="top_three_box">
              <div class="second_box top_three_common_class">
                <img class="rank2"
                     src="../../sprite/rank2.png"
                     alt="">
                <img class="avatar_url"
                     :src="topThree[1] && topThree[1].avatarUrl"
                     alt="">
                <img class="icon_rank2"
                     src="../../sprite/icon_rank2.png"
                     alt="">
                <p class="user_nicker">{{topThree[1] && topThree[1].userNicker}}</p>
                <p class="commision"><span>{{topThree[1] && topThree[1].saleAmountShort}}<span v-if="topThree[1] && topThree[1].saleAmount>10000">万</span></span><span>元</span></p>
              </div>
              <div class="first_box top_three_common_class">
                <img class="rank1"
                     src="../../sprite/rank1.png"
                     alt="">
                <img class="avatar_url"
                     :src="topThree[0] && topThree[0].avatarUrl"
                     alt="">
                <img class="icon_rank1"
                     src="../../sprite/icon_rank1.png"
                     alt="">
                <p class="user_nicker">{{topThree[0] && topThree[0].userNicker}}</p>
                <p class="commision"><span>{{topThree[0] && topThree[0].saleAmountShort}}<span v-if="topThree[0] && topThree[0].saleAmount>10000">万</span></span><span>元</span></p>
              </div>
              <div class="third_box top_three_common_class">
                <img class="rank3"
                     src="../../sprite/rank3.png"
                     alt="">
                <img class="avatar_url"
                     :src="topThree[2] && topThree[2].avatarUrl"
                     alt="">
                <img class="icon_rank3"
                     src="../../sprite/icon_rank3.png"
                     alt="">
                <p class="user_nicker">{{topThree[2] && topThree[2].userNicker}}</p>
                <p class="commision"><span>{{topThree[2] && topThree[2].saleAmountShort}}<span v-if="topThree[2] && topThree[2].saleAmount>10000">万</span></span><span>元</span></p>
              </div>
            </div>
            <div class="no_rank_data"
                 v-if="saleRanksList.length == 0">暂无佣金排行数据~</div>
            <div class="table_box">
              <div class="bodyIn">
                <div class="tableBody"
                     v-for="(item, index) in saleRanksList"
                     :key="index">
                  <div class="userInfo">
                    <img class="headImg"
                         :src="item.avatarUrl"
                         alt="">
                    <span class="name">{{item.userNicker}}</span>
                    <span class="rankNum">{{item.saleRank}}</span>
                  </div>
                  <div v-if="item.saleAmount > 10000"
                       class="money">{{item.saleAmountShort}}万元</div>
                  <div v-else
                       class="money">{{item.saleAmountShort}}元</div>
                </div>
              </div>
            </div>
          </div>
          <div class="community_box">
            <img class="bg"
                 src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/b4dd94e849f1441ab3b1221f7e8b4f38.png"
                 alt="">
            <img class="qdcode"
                 src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/40d9f55864bf42edaab5876745036aae.jpg"
                 alt="">
          </div>
          <div class="placard_box1"
               v-if="isActivityEnd2 && !isPublicityTimeEnd">
            <div class="tip">活动已结束</div>
            <div class="time">发奖公示时间：{{publicityStartDate}}</div>
          </div>
          <div class="placard_box2"
               v-if="isActivityEnd2 && isPublicityTimeEnd">
            <span class="left">活动已结束，点击查看发奖公示</span>
            <span class="right"
                  @click="goAwardPlacard">去查看</span>
          </div>
        </div>
        <div class="fixed_login_box">
          <div class="fixed_left">
            <img :src="token ? userInfo.avatarUrl : require('../../sprite/no_login.png')"
                 alt="">
            <div class="my_rank_info">
              <div class="my_ranking">我的排名：<span v-if="token && mySaleRank > 20">未入榜</span><span v-if="token && mySaleRank <= 20">{{mySaleRank}}</span><span v-if="!token">登录后可查看</span></div>
              <div class="my_commission">佣金：<span v-if="token">¥{{mySaleAmount}}</span><span v-if="!token">登录后可查看</span></div>
            </div>
          </div>
          <div class="fixed_right"
               v-if="!token"
               @click="goLogin">立即登录</div>
        </div>
      </div>
      <Rule v-if="showRulePopup"
            :isPromoteRuleShow="showRulePopup"
            @closeRulePopup="handleCloseRulePopup"></Rule>
      <div class="joinDialog"
           :class="isVisible ? 'showDialog' : 'hiddenDialog'">
        <div class="content">
          <div class="joinIn">
            <div class="title">
              <div>
                <img src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/d82109a544e04d9f8c66b50ca7a4604b.png"
                     alt="">
                <span>1.加入M-CLUB</span>
              </div>
              <span class="arr"></span>
              <div>
                <img src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/647fe0c3922a4d499805f06f7ebed93c.png"
                     alt="">
                <span>2.分享售卡</span>
              </div>
              <span class="arr"></span>
              <div>
                <img src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/2483fff2168f4fda8d9b2064da30175f.png"
                     alt="">
                <span>3.得返佣奖励</span>
              </div>
            </div>
            <div class="conter">
              <div class="user">
                <img :src="userInfo && userInfo.avatarUrl"
                     alt="">
                <span>{{userInfo && userInfo.nickName}}</span>
              </div>
              <div class="tip">加入M-CLUB省心赚</div>
              <div class="enterBtn"
                   @click="createUserInfo">确认协议并成为推广大使</div>
              <div class="agreement">我已同意以下协议：<span @click="viewAgreement('/serveAgreement')">《芒果TV M-CLUB芒果推广大使服务协议》</span><span @click="viewAgreement('/commissionAgreement')">《芒果TV
                  M-CLUB芒果推广大使佣金与行为规则》</span></div>
            </div>
          </div>
          <div class="close">
            <van-icon size="34"
                      color="#ffffff"
                      name="close"
                      @click="isVisible = false" />
          </div>
        </div>
      </div>

      <!-- 商品海报 -->
      <ProductPoster v-if="showProductPopup"
                     :show="showProductPopup"
                     :shareProduct="shareProduct"
                     :userInfo="userInfo"
                     :activityInfo="activityInfo"
                     pageType="activity"
                     @closePopup="handleClose"></ProductPoster>
    </div>
  </div>
</template>
<script>
import {
  getToken,
  urlParse,
  isMangguoApp,
  MGTVVIP_page_view,
  MGTVVIP_click_event
} from '../../utils/tokenUtils'
import mgLoginInfo from '../../utils/mgLoginInfo'
import { CreateUserInfo } from '../../service/home'
import {
  GetDataTimeNow,
  GetActivityInfo,
  GetProductListByIds,
  GetUserCommissionRankListByTime,
  GetIsJoinActivity,
  GetUserActivityInfo,
  GetActPrizeRecordInfo,
  JoinActivity
} from '../../service/activityDetails'
import Rule from './rule.vue'
import './index.less'
export default {
  components: { Rule },
  data() {
    return {
      // 线上的
      ids1: [], // 活动商品id（佣金加码）
      ids23: [22851207215130, 22721207215007, 22120727093730], // 活动商品id（月度榜单）
      // 测试的
      // ids1: [],
      // ids23: [22430902181821, 22320923144407, 22430902181821],

      current: -1, // 当前活动标签
      // 当前活动页签id（佣金加码：[1112104, 1112105, 1112106, 1112107]；月度榜单：1112103）
      currentId: 1112104,
      dateArr: [], // 活动时间页签（佣金加码）
      activityArr: [], // 2个活动的聚合（佣金加码）

      loading: false,
      isApp: isMangguoApp(),
      token: '',
      userInfo: {},
      isOutIn: false,
      isDisable: false, // 账号是否被禁用
      isAuthorized: false, // 是否授权初始化用户信息
      isVisible: false, // 授权弹窗显隐

      bonusCfg: [], // 进度条补贴门槛信息
      progressIn: 0,
      commissionOrderCount: 0, // 我的订单量（佣金加码）
      subsidyMoney: 0, // 补贴金（佣金加码）

      activityInfo: {}, // 活动信息
      activityInfo1: {}, // 活动信息（佣金加码）
      activityInfo2: {}, // 活动信息（月度榜单）
      productList1: [], // 商品list（佣金加码）
      productList23: [], // 商品list（月度榜单）

      mySaleRank: '', // 我的排名（月度榜单）
      mySaleAmount: '', // 我的佣金（月度榜单）
      topThree: [], // 排名前三
      saleRanksList: [],
      publicityStartDate: '2023-01-05 00:00:00', // 发奖公示开始时间
      publicityEndDate: '2023-01-05 23:59:59', // 发奖公示结束时间

      isBegin: false,
      nowTime: 0, // 当前时间时间戳（到秒 10位）
      endPublicityTime: 0, // 发奖公示时间戳
      isPublicityTimeEnd: false, // 是否到发奖公示时间

      isActivityStart1: false, // 活动是否开始（佣金加码）
      isActivityEnd1: false, // 活动是否结束（佣金加码）
      isActivityEnd2: false, // 活动是否结束（月度榜单）

      isJoinActivity1: false, // 是否已报名活动（佣金加码）

      showRulePopup: false, // 活动规则 popup
      showProductPopup: false, // 商品海报显隐
      shareProduct: {} // 当前分享的商品对象信息
    }
  },
  computed: {
    isShowFixedBtn() {
      if (this.current == 1) {
        if (this.isJoinActivity1 && !this.isActivityStart1) return true
        if (this.isJoinActivity1 && this.isActivityEnd1) return true
        if (!this.isJoinActivity1 && !this.isActivityStart1) return true
        if (
          !this.isJoinActivity1 &&
          this.isActivityStart1 &&
          !this.isActivityEnd1
        )
          return true
        if (!this.isJoinActivity1 && this.isActivityEnd1) return true
      }
    }
  },
  created() {
    this.endPublicityTime = new Date(
      this.publicityStartDate.replace(/-/g, '/')
    ).getTime()
    this.urlData = urlParse(window.location.href)
    // console.log(this.urlData, 'hhhh---this.urlData')
    this.loading = true
    this.getDataTimeNow()
  },
  mounted() {
    mgLoginInfo(this, 'activityDetailsDoubleTwelve', this.urlData.type)
    setTimeout(() => {
      if (
        !this.urlData.type ||
        this.urlData.type == 101 ||
        this.urlData.type == 102
      ) {
        this.current = 1
        this.activityInfo = this.activityInfo1
      }
      if (this.urlData.type == 2) {
        this.current = 2
        this.activityInfo = this.activityInfo2
      }
      // 埋点，会员数据上报（页面PV）
      let mgUuid = this.token ? this.userInfo.mgUuid : ''
      MGTVVIP_page_view(`${this.activityInfo.activityName}活动页`, mgUuid)
    }, 300)
  },
  methods: {
    async init() {
      await this.getActivityInfo_all()
      if (this.urlData.type == 101) {
        this.currentId = 1112104
      }
      if (this.urlData.type == 102) {
        this.currentId = 1112105
      }
      if (this.urlData.type == 103) {
        this.currentId = 1112106
      }
      if (this.urlData.type == 104) {
        this.currentId = 1112107
      }
      if (this.urlData.type == 2) {
        this.currentId = 1112103
      }
      await this.getActivityInfo(this.currentId)
      if (this.token && this.isAuthorized) {
        await this.getIsJoinActivity(this.currentId)
      }
      // await this.getProductListByIds1()
      await this.getProductListByIds23()
      this.loading = false
    },
    // 去登录
    goLogin() {
      const that = this
      if (isMangguoApp()) {
        MgtvApi.login(function (data) {
          if (data.code == 200) {
            mgLoginInfo(that, 'activityDetailsDoubleTwelve', this.urlData.type)
          }
        })
      } else {
        window.location.href = `https://m.mgtv.com/login/?from=${
          process.env.NODE_ENV == 'development'
            ? encodeURIComponent(window.location.href)
            : encodeURIComponent(window.location.href)
        }`
      }
    },
    // 确认授权成为大使
    createUserInfo() {
      CreateUserInfo({
        token: localStorage.getItem('token'),
        channelCode: this.urlData.channelCode,
        superiorId: this.urlData.superiorId,
        shareId: this.urlData.shareId
      }).then((res) => {
        const { code, data } = res
        if (code == '0') {
          localStorage.setItem('nickName', data.nickName)
          localStorage.setItem('avatarUrl', data.avatarUrl)
          localStorage.setItem('channelCode', data.channelCode)
          localStorage.setItem('mgUuid', data.mgUuid)
          localStorage.setItem('id', data.id)
          localStorage.setItem('shareId', data.shareId)
          localStorage.setItem('superiorId', data.superiorId)
          localStorage.setItem('userLevel', data.userLevel)
          this.isVisible = false
          this.isAuthorized = true // 是否授权初始化用户信息
          this.$toast('加盟成功')
        }
      })
    },
    // 点击 活动规则
    handleViewRule() {
      // this.$refs.refRule.isPromoteRuleShow = true
      this.showRulePopup = true
    },
    // 关闭活动规则
    handleCloseRulePopup() {
      this.showRulePopup = false
    },
    viewAgreement(e) {
      this.$router.push(e)
    },
    // 通过商品Ids获取商品信息（佣金加码）
    getProductListByIds1() {
      GetProductListByIds({
        ids: this.ids1
      }).then((res) => {
        const { code, data } = res
        if (code == '0') {
          this.productList1 = data.list || []
        }
      })
    },
    // 通过商品Ids获取商品信息（月度榜单）
    getProductListByIds23() {
      GetProductListByIds({
        ids: this.ids23
      }).then((res) => {
        const { code, data } = res
        if (code == '0') {
          this.productList23 = data.list || []
        }
      })
    },
    // 获取当前时间时间戳（到秒 10位）
    getDataTimeNow() {
      GetDataTimeNow().then((res) => {
        const { code, data } = res
        if (code == '0') {
          this.nowTime = Number('' + `${data}000`)
        }
      })
    },
    async getActivityInfo_all() {
      let obj1 = {},
        obj2 = {},
        obj3 = {},
        obj4 = {},
        allobj1 = {},
        allobj2 = {},
        allobj3 = {},
        allobj4 = {}
      await GetActivityInfo({ activityId: 1112104 }).then((res) => {
        const { code, data } = res
        if (code == '0') {
          allobj1 = data || {}
          obj1['id'] = data && data.id
          obj1['startTime'] = data && data.startTime
          obj1['endTime'] = data && data.endTime
          obj1['actDate'] =
            data &&
            `${data.startTime.slice(5, 10).split('-').join('.')}-${data.endTime
              .slice(5, 10)
              .split('-')
              .join('.')}`
        }
      })
      await GetActivityInfo({ activityId: 1112105 }).then((res) => {
        const { code, data } = res
        if (code == '0') {
          let sT = new Date(data.startTime.replace(/-/g, '/')).getTime() // 活动开始时间戳
          if (this.nowTime < sT) {
            // this.isBegin = false // 活动未开启
          }
          if (this.nowTime >= sT) {
            // this.isBegin = true // 活动已开启
            this.currentId = data && data.id
          }
          allobj2 = data || {}
          obj2['id'] = data && data.id
          obj2['startTime'] = data && data.startTime
          obj2['endTime'] = data && data.endTime
          obj2['actDate'] =
            data &&
            `${data.startTime.slice(5, 10).split('-').join('.')}-${data.endTime
              .slice(5, 10)
              .split('-')
              .join('.')}`
        }
      })
      await GetActivityInfo({ activityId: 1112106 }).then((res) => {
        const { code, data } = res
        if (code == '0') {
          let sT = new Date(data.startTime.replace(/-/g, '/')).getTime() // 活动开始时间戳
          if (this.nowTime < sT) {
            // this.isBegin = false // 活动未开启
          }
          if (this.nowTime >= sT) {
            // this.isBegin = true // 活动已开启
            this.currentId = data && data.id
          }
          allobj3 = data || {}
          obj3['id'] = data && data.id
          obj3['startTime'] = data && data.startTime
          obj3['endTime'] = data && data.endTime
          obj3['actDate'] =
            data &&
            `${data.startTime.slice(5, 10).split('-').join('.')}-${data.endTime
              .slice(5, 10)
              .split('-')
              .join('.')}`
        }
      })
      await GetActivityInfo({ activityId: 1112107 }).then((res) => {
        const { code, data } = res
        if (code == '0') {
          let sT = new Date(data.startTime.replace(/-/g, '/')).getTime() // 活动开始时间戳
          if (this.nowTime < sT) {
            this.isBegin = false // 活动未开启
          }
          if (this.nowTime >= sT) {
            this.isBegin = true // 活动已开启
            this.currentId = data && data.id
          }
          allobj4 = data || {}
          obj4['id'] = data && data.id
          obj4['startTime'] = data && data.startTime
          obj4['endTime'] = data && data.endTime
          obj4['actDate'] =
            data &&
            `${data.startTime.slice(5, 10).split('-').join('.')}-${data.endTime
              .slice(5, 10)
              .split('-')
              .join('.')}`
        }
      })
      this.dateArr = [obj1, obj2, obj3, obj4]
      this.activityArr = [allobj1, allobj2, allobj3, allobj4]
      // console.log(this.activityArr, 'vv')
    },
    // 活动信息（佣金加码、月度榜单）
    getActivityInfo(id) {
      GetActivityInfo({ activityId: id }).then((res) => {
        const { code, data } = res
        if (code == '0') {
          // （佣金加码）
          if (
            id == 1112104 ||
            id == 1112105 ||
            id == 1112106 ||
            id == 1112107
          ) {
            document.title = data && data.activityName
            this.activityInfo = data || {}
            this.activityInfo1 = data || {}
            this.bonusCfg = (data && data.bonusCfg) || [] // 进度条补贴门槛信息
            this.ids1 = (data && data.porductList) || [] // 活动商品id（佣金加码）
            this.getProductListByIds1()
            let sT = new Date(data.startTime.replace(/-/g, '/')).getTime() // 活动开始时间戳
            let eT = new Date(data.endTime.replace(/-/g, '/')).getTime() // 活动结束时间戳
            if (this.nowTime < sT) {
              // console.log('活动未开始')
              this.isActivityStart1 = false
            }
            if (this.nowTime >= sT) {
              // console.log('活动已开始')
              this.isActivityStart1 = true
            }
            // console.log('eT', eT)
            // console.log('this.nowTime', this.nowTime)
            // console.log('----活动', eT > this.nowTime)
            if (this.nowTime <= eT) {
              // console.log('活动未结束')
              this.isActivityEnd1 = false
            }
            if (this.nowTime > eT) {
              // console.log('活动已结束')
              this.isActivityEnd1 = true
            }
          }

          // （月度榜单）
          if (id == 1112103) {
            document.title = data && data.activityName
            let objs = JSON.parse(JSON.stringify(data || {}))
            for (let k in objs) {
              if (k == 'startTime' || k == 'endTime') {
                objs[k] = objs[k].slice(5, 10).split('-').join('月') + '日'
              }
            }
            this.activityInfo = data || {}
            this.activityInfo2 = objs
            let eT = new Date(data.endTime.replace(/-/g, '/')).getTime() // 活动结束时间戳
            // console.log('eT', eT)
            // console.log('this.nowTime', this.nowTime)
            // console.log('----活动', eT > this.nowTime)
            if (this.nowTime <= eT) {
              console.log('活动未结束')
              this.isActivityEnd2 = false
            }
            if (this.nowTime > eT) {
              console.log('活动已结束')
              this.isActivityEnd2 = true
            }
            this.getUserCommissionRankListByTime(data)
          }
        }
      })
    },
    // 排行榜list
    getUserCommissionRankListByTime(params) {
      this.topThree = []
      this.saleRanksList = []
      GetUserCommissionRankListByTime({
        startTime: params.startTime,
        endTime: params.endTime
      }).then((res) => {
        const { code, data } = res
        if (code == '0') {
          this.mySaleRank = data.mySaleRank
          this.mySaleAmount = data.mySaleAmount
          data.saleRanks &&
            data.saleRanks.forEach((item) => {
              if (item.saleAmount > 10000) {
                item.saleAmountShort = (item.saleAmount / 10000).toFixed(2)
              } else {
                item.saleAmountShort = item.saleAmount
              }
            })
          if (data.saleRanks.length > 0) {
            this.topThree = data.saleRanks.slice(0, 3)
            this.saleRanksList = data.saleRanks.slice(3, 20)
          }
          this.loading = false
        } else {
          this.loading = false
        }
      })
    },
    // 查询 是否已报名活动
    getIsJoinActivity(id) {
      GetIsJoinActivity({ activityId: id }).then((res) => {
        const { code, data } = res
        if (code == '0') {
          // （佣金加码）
          if (
            id == 1112104 ||
            id == 1112105 ||
            id == 1112106 ||
            id == 1112107
          ) {
            this.isJoinActivity1 = data
            // this.isJoinActivity1 = true // 自测用
            if (this.isJoinActivity1 == true) {
              this.getUserActivityInfo(id)
            }
          }
        }
      })
    },
    // 查询用户佣金/订单信息
    getUserActivityInfo(id) {
      GetUserActivityInfo({ activityId: id }).then((res) => {
        const { code, data } = res
        if (code == '0') {
          // （佣金加码）
          if (
            id == 1112104 ||
            id == 1112105 ||
            id == 1112106 ||
            id == 1112107
          ) {
            this.commissionOrderCount = data.commissionOrderCount || 0
            // this.commissionOrderCount = 1200 // 自测用
            let resAmount = this.commissionOrderCount
            let t1 = 0
            let s1 = 100 / 3 - 5
            let s2 = 100 / 3 + s1 - 5
            let s3 = 100 / 3 + s2 - 5
            let min0 = this.bonusCfg && this.bonusCfg[0].orderCountMinRequired
            let min1 = this.bonusCfg && this.bonusCfg[1].orderCountMinRequired
            let min2 = this.bonusCfg && this.bonusCfg[2].orderCountMinRequired
            let min3 =
              id == 1112104 || id == 1112106
                ? 1200
                : id == 1112107
                ? 1400
                : id == 1112105
                ? 880
                : 0
            console.log('resAmount', resAmount)
            if (resAmount > 0) {
              if (resAmount <= min0) {
                this.progressIn = ((resAmount / min0) * 100) / 3 - 5
              }
              if (resAmount <= min1 && resAmount > min0) {
                t1 = resAmount - min0
                this.progressIn = ((t1 / (min1 - min0)) * 100) / 3 + s1 - 5
              }
              if (resAmount <= min2 && resAmount > min1) {
                t1 = resAmount - min1
                this.progressIn = ((t1 / (min2 - min1)) * 100) / 3 + s2 - 5
              }
              if (resAmount > min2) {
                t1 = resAmount - min2
                this.progressIn = ((t1 / (min3 - min2)) * 100) / 3 + s3
              }
            } else {
              this.progressIn = 0
            }
            if (this.progressIn >= 100) {
              this.progressIn = 98
            }
            if (this.progressIn < 0) {
              this.progressIn = 1
            }
            console.log('this.progressIn', this.progressIn)

            if (
              this.bonusCfg &&
              this.bonusCfg.length > 0 &&
              this.commissionOrderCount >=
                this.bonusCfg[0].orderCountMinRequired
            ) {
              this.getActPrizeRecordInfo(id)
            }
          }
        }
      })
    },
    // （佣金加码）补贴金
    getActPrizeRecordInfo(id) {
      GetActPrizeRecordInfo({ activityId: id }).then((res) => {
        const { code, data } = res
        if (code == '0') {
          // （佣金加码）补贴金
          this.subsidyMoney = (data && data.prizeAmount) || 0
          console.log('this.subsidyMoney', this.subsidyMoney)
        }
      })
    },
    // 切换活动（佣金加码、榜单活动）
    handleCheckTab(t) {
      if (t == 101) {
        this.current = 1
        this.currentId = 1112104
        document.title = this.activityInfo1 && this.activityInfo1.activityName
      }
      if (t == 2) {
        document.title = this.activityInfo2 && this.activityInfo2.activityName
        this.current = 2
        this.currentId = 1112103
      }
      this.getActivityInfo(this.currentId)
      this.getIsJoinActivity(this.currentId)
      console.log(this.currentId, 'VVVVV----this.currentId')
    },
    // 切换时间页签
    async handleCheckDate(val) {
      // console.log('val：', val)
      await this.getDataTimeNow()
      let sT = new Date(val.startTime.replace(/-/g, '/')).getTime() // 活动开始时间戳
      if (this.nowTime < sT) {
        this.$toast('活动未开始，暂不能查看')
      }
      if (this.nowTime >= sT) {
        this.currentId = val.id
        this.getActivityInfo(val.id)
        this.getIsJoinActivity(val.id)
      }
    },
    // 立即报名（佣金加码）
    goJoin1() {
      if (this.isDisable) return
      if (!localStorage.getItem('token')) {
        this.goLogin()
        return
      }
      if (!this.isAuthorized) {
        this.isVisible = true
        return
      }
      if (!this.isActivityStart1) return this.$toast('活动未开始，暂无法报名~')
      if (this.isActivityEnd1) return this.$toast('活动已结束~')
      if (this.currentId == 1112104 || this.currentId == 1112105) {
        JoinActivity({ activityIds: [1112104, 1112105] }).then((res) => {
          const { code, data } = res
          if (code == '0') {
            this.getActivityInfo(this.currentId)
            this.getIsJoinActivity(this.currentId)
            this.$toast('报名成功，快去推广吧~')
          }
        })
      }
      if (this.currentId == 1112106) {
        JoinActivity({ activityIds: [1112106] }).then((res) => {
          const { code, data } = res
          if (code == '0') {
            this.getActivityInfo(this.currentId)
            this.getIsJoinActivity(this.currentId)
            this.$toast('报名成功，快去推广吧~')
          }
        })
      }
      if (this.currentId == 1112107) {
        JoinActivity({ activityIds: [1112107] }).then((res) => {
          const { code, data } = res
          if (code == '0') {
            this.getActivityInfo(this.currentId)
            this.getIsJoinActivity(this.currentId)
            this.$toast('报名成功，快去推广吧~')
          }
        })
      }
    },

    // 生成海报
    shareHandle(item) {
      if (this.isDisable) return
      if (!localStorage.getItem('token')) {
        this.goLogin()
        return
      }
      if (!this.isAuthorized) {
        this.isVisible = true
        return
      }
      setTimeout(() => {
        // 埋点，会员数据上报（点击事件）
        MGTVVIP_click_event(
          `${this.activityInfo.activityName}活动页-${item.productName}-点击商品分享赚`,
          this.userInfo.mgUuid
        )
      }, 200)
      this.shareProduct = item
      this.showProductPopup = true
    },
    handleClose() {
      this.showProductPopup = false
    },
    // 去活动奖励页面
    goEventRewards() {
      this.$router.push({
        path: '/eventRewards'
      })
    },
    // 去发奖公示页面
    goAwardPlacard() {
      this.$router.push({
        path: '/awardPlacard',
        query: {
          activityId: this.activityInfo2.id,
          publicityStartDate: this.publicityStartDate,
          publicityEndDate: this.publicityEndDate
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
</style>